import React, { Component } from 'react';
import { 
	Tab, 
	Tabs, 
	TabList, 
	TabPanel 
} from 'react-tabs';

class Brands extends Component {
	render() {
		return (
			<section className="brands">
				<div className="container-fluid">
					<h1 className="brands__tital">As Featured in</h1>
					<div className="row">
						<div className="col-12">
						<Tabs>
    						<TabList className="nav-tabs">
								<Tab>
									<span className="nav-link">
										<img style={{width: "200px"}} className="img-fluid" src="/images/brand/Techinasia.png"/>
									</span>
								</Tab>
								<Tab>
									<span className="nav-link">
										<img style={{width: "200px"}} className="img-fluid" src="/images/brand/Clozette.png"/>
									</span>
								</Tab>
								<Tab>
									<span className="nav-link">
										<img style={{width: "200px"}} className="img-fluid" src="/images/brand/Sydney.png"/>
									</span>
								</Tab>
								<Tab>
									<span className="nav-link">
										<img style={{width: "200px"}} className="img-fluid" src="/images/brand/Her world.png"/>
									</span>
								</Tab>
							</TabList>
								<div className="clearfix"></div>
								<div className="tab-content" id="brandTabContent">
									<TabPanel>
									<div className="tab-pane">
										<h1 className="brands__heading">“If you want streamlined skincare that works, here is a proven solution. Skincare stopped being an obligation, and something I found joy in again.”</h1>
									</div>
									</TabPanel>
									<TabPanel>
									<div className="tab-pane">
										<h1 className="brands__heading">“If you want streamlined skincare that works, here is a proven solution. Skincare stopped being an obligation, and something I found joy in again.”</h1>
									</div>
									</TabPanel>
									<TabPanel>
									<div className="tab-pane">
										<h1 className="brands__heading">“If you want streamlined skincare that works, here is a proven solution. Skincare stopped being an obligation, and something I found joy in again.”</h1>
									</div>
									</TabPanel>
									<TabPanel>
									<div className="tab-pane">
										<h1 className="brands__heading">“If you want streamlined skincare that works, here is a proven solution. Skincare stopped being an obligation, and something I found joy in again.”</h1>
									</div>
									</TabPanel>
								</div>
							</Tabs>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default Brands